<template>
  <div class="job-tasks">
    <a href="javascript:;" class="toggle" :class="{open: showTasks}" @click="showTasks = !showTasks">TASKS ({{ sortedTask.length }})</a>
    <div class="table-responsive tasks" v-if="showTasks && sortedTask.length">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th width="120"><a href="javascript:;" data-sort-field="seq_no" @click="doSort($event)" class="sort">NUMBER</a></th>
            <th><a href="javascript:;" data-sort-field="name" @click="doSort($event)" class="sort">TASK</a></th>
            <th width="200"><a href="javascript:;" data-sort-field="due_date" @click="doSort($event)" class="sort asc">DUE DATE</a></th>
            <th width="200"><a href="javascript:;"  data-sort-field="status" @click="doSort($event)" class="sort">STATUS</a></th>
            <th v-if="!IS_CLIENT" width="150"><a href="javascript:;" data-sort-field="actual_hours" @click="doSort($event)" class="sort">TOTAL TIME</a></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(task, index) in sortedTask" :key="index" @click="selectedTask = task" :class="{'selected': selectedTask && selectedTask.id == task.id}">
            <td>#{{ task.seq_no?task.seq_no:task.id }}</td>
            <td>{{ task.name }}</td>
            <td>{{ task.due_date | toHumanDate}}</td>
            <td>{{ task.status | statusToUCWords }}</td>
            <td v-if="!IS_CLIENT">{{ task.actual_hours }}h</td>
            <td><a href="javascript:;" class="float-right icon-trash" v-tooltip="'Delete Task'" @click="confDelete( index )"></a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <button type="button" class="btn btn-outline-black" @click="showModalAddTask = true">+ Add Task</button>

    <div class="task-details mt-4" v-if="selectedTask">
      <div class="task-head details-head">
        <div class="inn">
          <div class="task-info">
            <div class="title">
              <div class="float-right">
                <div class="dropdown">
                  <a href="javascript:;" class="status dropdown-toggle" :class="selectedTask.status" data-toggle="dropdown" @click="showStatusDropdown = !showStatusDropdown">{{ selectedTask.status | statusToUCWords}}</a>
                  <div class="dropdown-menu" :class="{show: showStatusDropdown == true}">
                    <a class="dropdown-item" href="javascript:;" @click="updateStatus(jstatus)" v-for="jstatus in taskStatuses" :key="jstatus" :value="jstatus">
                      {{ jstatus | statusToUCWords }}
                    </a>
                  </div>
                </div>
              </div>
              <span>TASK #{{ selectedTask.seq_no?selectedTask.seq_no:selectedTask.id }}&nbsp;|&nbsp;</span>
              <template v-if="editTaskName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newTaskName" ref="inputTitle" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ selectedTask.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                   @click="editTaskName = true"></a>
              </template>
            </div>
            <div class="form-row">
              <label style="color: #000;" class="lb">DUE DATE</label>
              <div class="inputs">
                <date-picker format="DD-MM-YYYY" value-type="YYYY-MM-DD" v-model="selectedTask.due_date" @change="updateDueDate" :editable="false" input-class="form-control" style="display: inline-block;"></date-picker>
              </div>
            </div>
            <template v-if="editDescription">
              <form method="post" @submit.prevent="updateDescription">
                <div class="form-group">
                  <editor :api-key="tinyApiKey" :init="tinyOpts" v-model="newDescription"></editor>
                </div>
                <button type="submit" class="btn btn-outline-black">Submit</button>&nbsp;
                <button type="button" class="btn btn-outline-gray" @click="editDescription = false">Cancel</button>
              </form>
            </template>
            <template v-else>
              <div class="desc">
                <div v-if="selectedTask.description" v-html="selectedTask.description"></div>
                <div v-else><em>No description...</em></div>
              </div>
              <button type="button" class="btn btn-outline-black w180 mt-4" @click="editDescription = true">Edit Task Description</button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <modal-add-task v-model="showModalAddTask" @task-modal-close="onTaskModalClose" @task-created="onTaskCreated"></modal-add-task>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ModalAddTask from './ModalAddTask.vue'
import ServiceTask from '@/services/task'
import Editor from '@tinymce/tinymce-vue'
import DatePicker from 'vue2-datepicker';
import { orderBy } from 'lodash'
import jquery from "jquery"

export default {
  components: {
    DatePicker,
    ModalAddTask,
    Editor
  },
  data () {
    return {
      showTasks: false,
      showModalAddTask: false,
      selectedTask: null,
      state: '',
      updated_dtm: 0,
      editTaskName: false,
      editDescription: false,
      showStatusDropdown: false,
      sortedTask: [],
      sort: 'due_date',
      order: 'asc'
    }
  },
  watch: {
    editTaskName (newVal) {
      let self = this;
      if ( newVal ) {
        self.newTaskName = self.selectedTask.name;
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    },
    editDescription (newVal) {
      let self = this;
      if ( newVal ) {
        self.newDescription = self.selectedTask.description;
      }
    },
  },
  computed: {
    ...mapGetters(['JOB', 'JOB_TASKS', 'IS_CLIENT']),
    ...mapState({
      taskStatuses: state => state.option.taskStatuses,
      tinyApiKey: state => state.option.tinyApiKey,
      tinyOpts: state => state.option.tinyOpts
    })
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.sortedTask = orderBy(this.JOB_TASKS, [this.sort], [this.order]);
      this.showModalAddTask = false;
      this.showTasks = true;
    },
    onTaskCreated (task) {
      this.showModalAddTask = false;
      this.$store.dispatch('ADD_JOB_TASK', task );
      this.sortedTask = orderBy(this.JOB_TASKS, [this.sort], [this.order]);
      this.showTasks = true;
    },
    onTaskModalClose () {
      this.showModalAddTask = false;
    },
    updateName () {
      let self = this;
      // save to DB
      setTimeout(() => {
        if(self.newTaskName != self.selectedTask.name){
          self.selectedTask.name = self.newTaskName;
          self.saveTask({name: self.newTaskName});
        }
        self.editTaskName = false;
      }, 1000);
    },
    updateDescription () {
      let self = this;
      // save to DB
      setTimeout(() => {
        if(self.newDescription != self.selectedTask.description){
          self.selectedTask.description = self.newDescription;
          self.saveTask({description: self.newDescription});
        }
        self.editDescription = false;
      }, 1000);
    },
    updateStatus (newStatus) {
      let self = this;
      if(newStatus != self.selectedTask.status){
        self.status = newStatus;
        self.saveTask({status: newStatus});
      }
      self.showStatusDropdown = false;
    },
    updateDueDate () {
      this.saveTask({due_date: this.selectedTask.due_date});
    },
    saveTask (updateData) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      self.state = 'saving';
      ServiceTask.save(self.selectedTask.id, updateData, task => {
        let now = new Date().getTime();
        if(now - self.updated_dtm > 5*1000){
          self.$notify({
            type: 'success',
            text: 'Task updated'
          });
          self.updated_dtm = now;
        }
        self.state = '';
        self.selectedTask.status = task.status;
      }, () => {
        self.state = '';
      });
    },
    confDelete ( index ) {
      let self = this, item = self.sortedTask[index];
      self.$dialog
        .confirm('Are you sure you want to delete task <strong>' + item.name + '</strong>?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceTask.delete(item.id, () => {
            dialog.close();
            self.$notify({
              type: 'success',
              text: 'Task <strong>' + item.name + '</strong> has been deleted'
            });
            self.$store.dispatch('GET_JOB', self.JOB.id);
          });
        })
        .catch(() => {})
      ;
    },
    doSort (event) {
      let self = this, params = {}, header = event.target;

      // Go through all header and reset the sort class
      jquery('.sort').not(header).attr('class', 'sort');

      if (typeof header.dataset.sortField != 'undefined') {
        params['sort'] = header.dataset.sortField;
        if (header.className.indexOf('asc') == -1) {
          /* Not sort or in desc */
          params['order'] = 'asc';
          header.className = header.className.replace(' desc', '') + ' asc';
        } else if (header.className.indexOf('desc') == -1) {
          params['order'] = 'desc';
          header.className = header.className.replace(' asc', '') + ' desc';
        }
        self.sort = params['sort'];
        self.order = params['order'];
        self.sortedTask = orderBy(self.JOB_TASKS, [self.sort], [self.order]);
      }
    },
  }
}
</script>
